import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import './LandingPage.scss'
import { useGetAppStatusQuery } from '../../store/api/appStatusApi'
import { useAppUi } from '../../utils/useAppUi'
import { APP_THEMES } from '../../utils/appTheme'
import { AppType } from '../../utils/appType'
import { BRANDS } from '../../utils/brand'
import { haptic } from '../../utils/fx'

const OPTIONS: { type: AppType; tagline: string }[] = [
  { type: 'sushi', tagline: 'Rulouri, seturi și bucurie' },
  { type: 'catering', tagline: 'Platouri pentru orice ocazie' },
]

const LandingPage = () => {
  const navigate = useNavigate()
  const { data: appStatus } = useGetAppStatusQuery()
  useAppUi()

  const disabled: Record<AppType, boolean> = {
    sushi: appStatus?.isSushiDisabled ?? false,
    catering: appStatus?.isCateringDisabled ?? false,
  }

  useEffect(() => {
    if (!appStatus) return
    if (appStatus.isSushiDisabled && !appStatus.isCateringDisabled) {
      navigate('/catering', { replace: true })
    } else if (appStatus.isCateringDisabled && !appStatus.isSushiDisabled) {
      navigate('/sushi', { replace: true })
    }
  }, [appStatus])

  return (
    <div className='landing-page'>
      <h1 className='landing-page__title'>
        Ce poftești azi?
      </h1>
      <div className='landing-page__options'>
        {OPTIONS.map(({ type, tagline }, index) => {
          const theme = APP_THEMES[type]
          const brand = BRANDS[type]

          return (
            <button
              key={type}
              className={`landing-page__option${disabled[type] ? ' disabled' : ''}`}
              disabled={disabled[type]}
              style={
                {
                  '--tone': theme.primary,
                  '--tone-soft': theme.primarySoft,
                  '--tone-rgb': theme.primaryRgb,
                  '--i': index,
                } as React.CSSProperties
              }
              onClick={() => {
                haptic(10)
                navigate(`/${type}`)
              }}
            >
              <span className='landing-page__emoji' aria-hidden>
                {theme.icons.slice(0, 3).map((icon, i) => (
                  <span key={i} style={{ '--e': i } as React.CSSProperties}>
                    <FontAwesomeIcon icon={icon} />
                  </span>
                ))}
              </span>
              <img src={brand.mascot} alt='' className='landing-page__option-logo' />
              <span className='landing-page__option-name'>
                {brand.first} <b>{brand.second}</b>
              </span>
              <span className='landing-page__option-tagline'>
                {disabled[type] ? 'Momentan indisponibil' : tagline}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default LandingPage
